import reader from './reader/reducer';
import library from './library/reducer';
import { combineReducers } from 'redux';
import onboarding from './onboarding/reducer';

export default combineReducers({
  reader,
  library,
  onboarding,
});



// WEBPACK FOOTER //
// ./src/app/api/redux-ui/common/reducer.js